import { Link } from 'react-router-dom'
import PlacesAutocomplete from '../components/Searchmaps'

import K from '../services/k'
import React, { useEffect, useState } from 'react'
import Axios from 'axios'

// Apple review snackbar
import MuiAlert from '@mui/material/Alert'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

function Home(props) {
  const [theme, setTheme] = React.useState('')

  useEffect(() => {
    if (theme != props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const [bMaintenance, setbMaintenance] = React.useState(false)

  const [maincategories, setmaincategories] = useState([])

  //get value of search stored
  useEffect(() => {
    window.scrollTo(0, 0)

    var target_date = new Date(
      new Date('11/29/2021').toLocaleString('en-US', { timeZone: 'Etc/GMT-5' }),
    ) // set the countdown date
    var days, hours, minutes, seconds // variables for time units

    var countdown = document.getElementById('tiles') // get tag element

    // getCountdown();

    setInterval(function () {
      getCountdown()
    }, 1000)

    function getCountdown() {
      // find the amount of "seconds" between now and target
      var current_date = new Date().getTime()
      var seconds_left = (target_date - current_date) / 1000

      days = pad(parseInt(seconds_left / 86400))
      seconds_left = seconds_left % 86400

      hours = pad(parseInt(seconds_left / 3600))
      seconds_left = seconds_left % 3600

      minutes = pad(parseInt(seconds_left / 60))
      seconds = pad(parseInt(seconds_left % 60))

      // format countdown string + set tag value
      countdown.innerHTML =
        '<span>' +
        days +
        '</span><span>' +
        hours +
        '</span><span>' +
        minutes +
        '</span><span>' +
        seconds +
        '</span>'
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n
    }

    Axios.get(`${K.baseUrl}users/maincategories`)
      .then((resp) => {
        if (resp && resp.message && resp.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        if (resp.data.resultcode === 1) {
          setmaincategories(resp.data.categories)
        }
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message &&
          error.response.data.message.indexOf('log in') > -1
        ) {
          props.logOut()
          return
        }
      })
  }, [])
  const token = localStorage.getItem(['__react_session__'])
  const jsontoken = JSON.parse(token)
  var options = {
    types: ['(cities)'],
  }

  const searchRestaurantByCategory = (maincategory) => {
    localStorage.setItem('maincategory', maincategory.id)
    window.location.href = '/restaurants'
  }

  const openRestaurant = (restaurantId) => {
    localStorage.setItem('restaurantId', restaurantId)
    window.location.href = '/single-restaurant'
  }

  // snackbar
  const [open, setOpen] = React.useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  // fetching restaurants

  const [popularRestaurants, setPopularRestaurants] = useState([])
  const [newRestaurants, setNewRestaurants] = useState([])
  const [featuredRestaurants, setFeaturedRestaurants] = useState([])

  const toprestaurants = async () => {
    var popularRes = []
    var newRes = []
    var featuredRes = []
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/restaurants`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }

    if (
      resp &&
      resp.data &&
      resp.data.response &&
      resp.data.response.length > 0
    ) {
      resp.data.response.forEach((item) => {
        if (item && item.restaurant) {
          if (item.restaurant.is_popular) {
            popularRes.push(item.restaurant)
          }
          if (item.restaurant.is_featured) {
            featuredRes.push(item.restaurant)
          }
          if (item.restaurant.is_new) {
            newRes.push(item.restaurant)
          }
        }
      })
    }
    setPopularRestaurants(popularRes)
    setFeaturedRestaurants(featuredRes)
    setNewRestaurants(newRes)
  }
  useEffect(() => {
    toprestaurants()
  }, [])

  return (
    <>
      <div
        className={theme && theme == 'DARK' ? 'dark_theme' : 'light_theme'}
        style={{ marginBottom: '-90px' }}
      >
        <div className="main-wrapper landingpage">
          {bMaintenance && (
            <section
              className="home-hero-banner home center-bg"
              style={{ minHeight: '100vh', backgroundPositionX: '100%' }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-7">
                    <div className="banner-content_">
                      <h3
                        // className="mt-5"
                        style={{ marginTop: 200 }}
                      >
                        Sorry for the delay
                      </h3>
                      <p style={{ fontSize: 24, marginTop: 20 }}>
                        Construction is taking longer than expected, we
                        apologize for the delay. The roads will open at 0900 31
                        Jan.
                      </p>
                      <p style={{ fontSize: 24, marginTop: 20 }}>
                        <b>Please note:</b> During construction, our login,
                        ordering and searching functionalities are not
                        available.
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-5">
                    <div
                      id="carouselExampleControls"
                      className="carousel slide mt-5 mb-5"
                      data-ride="carousel"
                    >
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <img
                            className="d-block w-100"
                            src="images/maintenance.png"
                            alt="Second slide"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          <section
            className="hero-banner home center-bg"
            style={{ backgroundPositionX: '100%' }}
          >
            {bMaintenance && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <img
                    src="images/maintenance.png"
                    alt="Maintenance"
                    style={{ width: '30%' }}
                  />
                </div>
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                  <h2>Sorry for the delay</h2>
                  <p style={{ fontSize: 24, marginTop: 20 }}>
                    But we are building a better road. Construction will be from
                    2100 Thursday 13 Jan to 0900 17 Jan.
                  </p>
                  <span></span>
                  <p style={{ fontSize: 24, marginTop: 20 }}>
                    <b>Please note:</b> During construction, our login, ordering
                    and searching functionalities are not available.
                  </p>
                </div>
              </div>
            )}

            <div className="container">
              <div className="row" style={{ paddingTop: '0px' }}>
                <div className="col-sm-7">
                  <div className="banner-content_">
                    <div className="d-none">
                      <div id="countdown">
                        <div id="tiles"></div>
                        <div className="labels">
                          <li>Days</li>
                          <li>Hours</li>
                          <li>Mins</li>
                          <li>Secs</li>
                        </div>
                      </div>
                    </div>

                    <h3
                      className="countdown-caption d-none"
                      style={{ color: '#19B400' }}
                    >
                      Starting Gate Opens in
                    </h3>

                    {
                      <form className="mt-5 d-none">
                        <div className="search-inner">
                          <PlacesAutocomplete
                            options={options}
                          ></PlacesAutocomplete>
                          <button type="submit">
                            <img
                              src="images/search-icn.png"
                              width="52.66"
                              height="52.66"
                              alt="icons arrow"
                            />
                          </button>
                        </div>
                      </form>
                    }

                    <div className="d-none">
                      <h2 className="mt-5" style={{ marginTop: 50 }}>
                        We are entering our{' '}
                        <span style={{ color: '#19B400' }}>BETA Testing</span>{' '}
                        phase to make sure our APPs and Service is Top Notch for
                        the people of Montego Bay. <br></br>
                        <br></br>
                        We will be opening{' '}
                        <span style={{ color: '#19B400' }}>
                          Thursday 3 Feb to Wed 9 Feb
                        </span>{' '}
                        during the hours of{' '}
                        <span style={{ color: '#19B400' }}>3 PM to 7 PM.</span>{' '}
                        <br></br>
                      </h2>
                      <br></br>
                      <p>
                        During this time, we will ONLY provide services to those
                        in our focus group, thanks again for your understanding
                        and support Use code{' '}
                        <span style={{ color: '#19B400' }}>BETA2022</span>{' '}
                        during the BETA Test and wave goodbye to your
                        service-fee – our way of saying thanks.{' '}
                      </p>
                    </div>

                    <div className="category_search">
                      <div className="row">
                        <div className="col-12 mt-5">
                          <div className="d-inline-block mb-3">
                            <h3 className="mr-4">
                              Browse Restaurants by Categories
                            </h3>
                            <div
                              style={{
                                borderTop: '5px solid #FFCC4D',
                                marginLeft: '45%',
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row pb-2"
                        style={{ flexWrap: 'nowrap', overflow: 'auto' }}
                      >
                        {maincategories.map((maincategory, index) => (
                          <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            className="text-center m-2 d-block"
                            onClick={() => {
                              searchRestaurantByCategory(maincategory)
                            }}
                          >
                            <img
                              className="img-back"
                              style={{
                                width: 50,
                                height: 50,
                                borderRadius: 25,
                              }}
                              src={
                                `${K.imageBaseUlr}` +
                                '/images_fd/' +
                                maincategory.image
                              }
                              title={maincategory.description}
                            />
                            <div
                              style={{ fontSize: '9px', letterSpacing: 0 }}
                              className={
                                'badge badge-success d-block text-white m-0 mt-1'
                              }
                            >
                              {maincategory.name}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="row">
                        <div className="col-12 mt-4 mb-0">
                          <Link
                            className="yellow-btn"
                            style={{ color: 'black' }}
                            to="#"
                            data-toggle="modal"
                            data-target="#searchPlacemodal"
                          >
                            Find Restaurants by Location{' '}
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="d-none_">
                      <h1 style={{ marginTop: 50 }}>
                        We deliver all the delicious delicacies to your
                        door-step
                      </h1>
                      <h1 style={{ color: '#19B400' }}>anytime *</h1>
                      <p className="mt-5">
                        Order all your favourite meals
                        <img
                          className="ml-1"
                          src="images/emoji-3.png"
                          width="20"
                        />
                        , snacks{' '}
                        <img
                          className="ml-1 mr-2"
                          src="images/emoji-2.png"
                          width="20"
                        />
                        and drinks{' '}
                        <img
                          className="ml-1 mr-2"
                          src="images/emoji-4.png"
                          width="20"
                        />
                        from all the restaurants near you and get a speedy-fast
                        delivery
                        <img
                          className="ml-1"
                          src="images/emoji-5.png"
                          width="20"
                        />
                        <img
                          className="ml-1"
                          src="images/emoji-1.png"
                          width="20"
                        />
                        <br></br>
                        *Based on Restaurant availability
                      </p>
                    </div>

                    {jsontoken !== null &&
                    jsontoken.address &&
                    jsontoken.address !== '' &&
                    jsontoken.address !== null ? (
                      <div className="d-none">
                        Delivery currently set to{' '}
                        <strong>{jsontoken.address}</strong>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className="col-sm-5">
                  <div
                    id="carouselExampleControls"
                    className="carousel slide mt-5 mb-5"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img
                          className="d-block w-100"
                          src="images/Store.png"
                          alt="Second slide"
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          className="d-block w-100"
                          src="images/Scooter.png"
                          alt="Third slide"
                        />
                      </div>
                    </div>

                    <a
                      className="carousel-control-prev"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Previous</span>
                    </a>
                    <a
                      className="carousel-control-next"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="popular-restaurant mt-5"
            style={{ backgroundPositionX: '100%' }}
          >
            {popularRestaurants.length > 0 && (
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="d-inline-block mb-3">
                      <h3 className="mr-4">Popular Restaurants</h3>
                      <div
                        style={{
                          borderTop: '5px solid #FFCC4D',
                          marginLeft: '45%',
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="row mt-0 mb-5">
                  {popularRestaurants.map((restaurantsingle, index) => (
                    <div
                      className="col-sm-4 p-4"
                      key={index}
                      onClick={() => {
                        openRestaurant(restaurantsingle.id)
                      }}
                    >
                      <div style={{ cursor: 'pointer' }}>
                        <div className="div-popular-restaurant hover15">
                          <figure>
                            <img
                              className="img-back"
                              src={`${K.imageBaseUlr}img/${restaurantsingle?.image}`}
                              style={{ width: '100%' }}
                              alt="restaurantimage"
                            />
                          </figure>
                          <div className="restaurant-detail">
                            <div className="div-rating mt-2">
                              <i className="fa fa-star mr-1"></i>
                              <span>
                                {parseFloat(restaurantsingle?.rating).toFixed(
                                  1,
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {featuredRestaurants.length > 0 && (
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="d-inline-block mb-3">
                      <h3 className="mr-4">Featured Restaurants</h3>
                      <div
                        style={{
                          borderTop: '5px solid #FFCC4D',
                          marginLeft: '45%',
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="row mt-0 mb-5">
                  {featuredRestaurants.map((restaurantsingle, index) => (
                    <div
                      className="col-sm-4 p-4"
                      key={index}
                      onClick={() => {
                        openRestaurant(restaurantsingle.id)
                      }}
                    >
                      <div style={{ cursor: 'pointer' }}>
                        <div className="div-popular-restaurant hover15">
                          <figure>
                            <img
                              className="img-back"
                              src={`${K.imageBaseUlr}img/${restaurantsingle?.image}`}
                              style={{ width: '100%' }}
                              alt="restaurantimage"
                            />
                          </figure>
                          <div className="restaurant-detail">
                            <div className="div-rating mt-2">
                              <i className="fa fa-star mr-1"></i>
                              <span>
                                {parseFloat(restaurantsingle?.rating).toFixed(
                                  1,
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {newRestaurants.length > 0 && (
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="d-inline-block mb-3">
                      <h3 className="mr-4">New Restaurants</h3>
                      <div
                        style={{
                          borderTop: '5px solid #FFCC4D',
                          marginLeft: '45%',
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="row mt-0 mb-5">
                  {newRestaurants.map((restaurantsingle, index) => (
                    <div
                      className="col-sm-4 p-4"
                      key={index}
                      onClick={() => {
                        openRestaurant(restaurantsingle.id)
                      }}
                    >
                      <div style={{ cursor: 'pointer' }}>
                        <div className="div-popular-restaurant hover15">
                          <figure>
                            <img
                              className="img-back"
                              src={`${K.imageBaseUlr}img/${restaurantsingle?.image}`}
                              style={{ width: '100%' }}
                              alt="restaurantimage"
                            />
                          </figure>
                          <div className="restaurant-detail">
                            <div className="div-rating mt-2">
                              <i className="fa fa-star mr-1"></i>
                              <span>
                                {parseFloat(restaurantsingle?.rating).toFixed(
                                  1,
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="container">
              <div className="row">
                <div className="col-12 d-flex">
                  <div className="d-inline-block mx-auto">
                    <h3 className="mr-4">Let’s do it together</h3>
                    <div
                      style={{
                        borderTop: '5px solid #FFCC4D',
                        marginLeft: '45%',
                      }}
                    ></div>
                  </div>
                </div>
                <div className="let-together-list mt-5">
                  <div className="col-1"></div>
                  <div className="col-10">
                    <div className="row">
                      <div className="col-sm-4 p-4">
                        <div className="item">
                          <div></div>
                          <img
                            src="images/letsdo-3.png"
                            width="200"
                            height="200"
                            alt="become rider"
                          />
                          <h3>Become a Roadie</h3>
                          <p>
                            Our service empowers drivers to make extra money on
                            the side.
                            <br />
                            You get to be your own boss, enjoying the freedom of
                            setting your work hours.
                            {/* Our new delivery app empowers drivers like you
                              <br /> to make extra money on the side.
                              <br /> You get to be your own boss enjoying the freedom of setting your hours.
                              <br /> We are happy you are considering being a part of the RoadJockey team. */}
                          </p>
                          <Link to="/roadies">
                            <button className="yellow-btn">Join Us </button>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-4 p-4">
                        <div className="item">
                          <img
                            src="images/letsdo-2.png"
                            width="200"
                            height="200"
                            alt="become partner"
                          />
                          <h3>Become a Partner</h3>
                          <p>
                            Scale your restaurant business by tapping into the
                            online ordering/delivery market without dealing with
                            the hassle of hosting the delivery in-house.
                            {/* Scale your restaurant business by signing up as one of our food partners.
                              You’ll get an easy-to-navigate listing to present all your dining information,
                              including the mouthwatering photos of your best meals.
                              We also offer grocery listings for local shops that want to increase their revenue potential. */}
                          </p>
                          <Link to="/partner">
                            <button className="yellow-btn">Join Us </button>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-4 p-4">
                        <div className="item">
                          <img
                            src="images/letsdo-1.png"
                            width="200"
                            height="200"
                            alt="careers"
                          />
                          <h3>Become Family</h3>
                          <p>
                            Ready for an exciting new challenge? If you’re
                            ambitious, humble, and love working with others,
                            then we want to hear from you! <br /> &nbsp;
                          </p>
                          <Link to="/careers">
                            <button className="yellow-btn">Join Us </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-1"></div>
                </div>
              </div>
            </div>
          </section>

          <section className="get-app" style={{ backgroundPositionX: '100%' }}>
            <div className="container">
              <div className="row mb-5 text-center">
                <div className="col-sm-12 p-5">
                  <div>
                    <img
                      className="m-3"
                      src="images/app_user.png"
                      style={{
                        width: '22%',
                        maxWidth: '400px',
                      }}
                    />
                    <img
                      className="m-3"
                      src="images/app_roadie.png"
                      style={{
                        width: '22%',
                        maxWidth: '400px',
                      }}
                    />
                    <img
                      className="m-3"
                      src="images/app_merchant.png"
                      style={{
                        width: '22%',
                        maxWidth: '400px',
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    <h5>
                      Check out our suite of{' '}
                      <span style={{ color: 'rgb(25, 180, 0)' }}>
                        CONVENIENT
                      </span>{' '}
                      apps. Download them, they are{' '}
                      <span style={{ color: 'rgb(25, 180, 0)' }}>FREE</span>
                    </h5>
                    <h5>Available for both Android and iOS</h5>
                  </div>
                  <div className="mt-0">
                    <a
                      href="https://apps.apple.com/us/app/road-jockey/id1595594217?platform=iphone"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="m-5"
                        src="https://roadjockey.com/images/img-apple-btn.png"
                        style={{ height: '50px' }}
                      />
                    </a>

                    <a
                      href="https://play.google.com/store/search?q=road%20jockey%20llc&c=apps"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="m-5"
                        src="https://roadjockey.com/images/img-google-btn.png"
                        style={{ height: '50px' }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="get-app d-none"
            style={{ backgroundPositionX: '100%' }}
          >
            <div className="container">
              <div className="row mt-4 mb-5">
                <div className="col-sm-4 p-5">
                  <img
                    src="images/phone.png"
                    style={{
                      width: '100%',
                      maxWidth: '400px',
                      marginTop: '70px',
                    }}
                  />
                </div>
                <div className="col-sm-8">
                  <div>
                    <img
                      src="images/couponnobg.png"
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className="d-inline-block mt-5">
                    <h3 className="mr-4">Get the RoadJockey App</h3>
                    <div
                      style={{
                        borderTop: '5px solid #FFCC4D',
                        marginLeft: '45%',
                      }}
                    ></div>
                  </div>

                  <h3 className="mr-4 mt-5">
                    Convenience Expedited with our App.
                  </h3>

                  <div className="mt-5">
                    <a
                      href="https://apps.apple.com/us/app/road-jockey-food/id1595594217"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="m-3"
                        src="https://roadjockey.com/images/img-apple-btn.png"
                        style={{ height: '100px' }}
                      />
                    </a>
                    {/* <Snackbar
                      open={open}
                      autoHideDuration={6000}
                      onClose={handleClose}
                    >
                      <Alert onClose={handleClose} sx={{ width: "100%" }}>
                        Hello friends. Road Jockey's much anticipated Android
                        app is up and running. <br></br>
                        Unfortunately however, due to circumstances beyond our
                        control, <br></br>
                        our IOS is still pending update and where we have to now
                        revert to our web page to facilitate orders.<br></br>
                        We trust that you will bear with us until this matter is
                        resolved.
                      </Alert>
                    </Snackbar> */}

                    <a
                      href="https://play.google.com/store/apps/details?id=com.roadjockey.userfood"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="m-3"
                        src="https://roadjockey.com/images/img-google-btn.png"
                        style={{ height: '100px' }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default Home
